import { render, staticRenderFns } from "./EpPersonForm.vue?vue&type=template&id=b505e7bc&"
import script from "./EpPersonForm.vue?vue&type=script&lang=js&"
export * from "./EpPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b505e7bc')) {
      api.createRecord('b505e7bc', component.options)
    } else {
      api.reload('b505e7bc', component.options)
    }
    module.hot.accept("./EpPersonForm.vue?vue&type=template&id=b505e7bc&", function () {
      api.rerender('b505e7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/EpPersonForm.vue"
export default component.exports